import React, { useState } from "react";
import { FaRightFromBracket } from "react-icons/fa6";
import { useAuth } from "./context/AuthContext";

const Header: React.FC = () => {
    const { user, logout } = useAuth();

    const [showUserProfile, setShowUserProfile] = useState(false);

    if (!user) return;

    return (
        <header className="z-20 w-full text-gray-200">
            <nav className="container mx-auto flex w-full items-center justify-between px-4 py-2">
                <span className="text-2xl font-bold text-white lg:text-3xl">Lisa</span>

                {/* <span className="text-xl font-bold text-white lg:text-2xl 2xl:text-3xl">Lisa</span> */}
                {/* <h1 className="text-white 2xl:text-2xl font-semibold capitalize">
          Automated Customer Invoice creation in SAP FI (using Gen AI)
        </h1> */}
                {user.isLoggedIn && (
                    <div className="hidden items-center gap-6 md:flex">
                        {/* <img src={ltimLogoWhite} className="block h-7 w-auto" /> */}
                        {user.roles.includes("superuser") && (
                            <button
                                className="cursor-pointer rounded-lg border border-gray-700 px-6 py-3 text-sm font-semibold hover:bg-gray-950/80"
                                onClick={() => window.open("https://callinsights.drake-ltim.com")}
                            >
                                Insights
                            </button>
                        )}
                        <div data-tooltip-id="my-tooltip" data-tooltip-content="Logout" data-tooltip-place="bottom">
                            <FaRightFromBracket className="cursor-pointer fill-gray-50 text-lg transition-all" onClick={logout} />
                        </div>
                        <div className="relative flex cursor-pointer items-center gap-4 rounded-full">
                            <div
                                className="flex h-10 w-10 items-center justify-center rounded-full bg-white"
                                onMouseOver={() => setShowUserProfile(true)}
                                onMouseLeave={() => setShowUserProfile(false)}
                            >
                                <span className="inline-block font-bold text-indigo-900">{user.name.substring(0, 2).toUpperCase()}</span>
                            </div>

                            {showUserProfile && (
                                <div className="absolute bottom-[-4rem] right-0 max-w-[150px] rounded-md bg-[#042f2e] p-2">
                                    <span className="block truncate text-xs font-semibold text-zinc-200">
                                        {user.name.charAt(0).toUpperCase() + user.name.substring(1)}
                                    </span>
                                    <span className="block truncate text-[0.7rem] text-zinc-200">{user.email}</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </nav>
            {/* <img
        src={ltimLogoBlue}
        className="fixed bottom-4 left-4 h-6 2xl:h-8 w-auto"
      /> */}
        </header>
    );
};

export default Header;
